import router from "../router";

export function Router() {
    return router;
}
